import {Token, TokenAction, TokenInvasif, TokenKata, TokenLocal, TokenQuizz} from './Token'
import Quizz from './Quizz.json'
import Quizztest from './Quizz'
import message from '@/game/assets/message.png'
import gagne from '@/game/assets/gagne.png'
import pasmal from '@/game/assets/pasmal.png'
import perdu from '@/game/assets/perdu.png'
import axios from 'axios'

const DEFAULT_WIDTH = 1200;
const DEFAULT_HEIGHT = 900;
const screenWidth = window.innerWidth;
const screenHeight = window.innerHeight;
const scale = Math.min(screenWidth/DEFAULT_WIDTH,screenHeight/DEFAULT_HEIGHT);

export default class TokenBag extends Phaser.GameObjects.Container {

    constructor(scene, tokenMultiplier, textInvasif, textNaturel) {
        super(scene);
        this.initondrag = [false,false,false,false,false];
        this.drag = false;
        this.idtoken = 0;
        //var correspondance = [[0,2],[1,2],[1,3]]
        var correspondance = [[0,1,2,3,4,5,6,7],[0,1,2,3,5,6,7],[0,1,2,3,5,6,7],[0,1,3,5,6,7],[0,3,5,6,7]]//PACA, Ligurie, Toscane, Corse, Sardaigne
        this.listQ = Array.from(Array(30).keys());
        this.nbQ = 0;
        let randomTokensLocal = this.randomTokensLocal(correspondance);
        this.regioncorrespondance = [];
        //this.countTokenTour2 = {0:{local:0,invasif:0},1:{local:0,invasif:0},2:{local:0,invasif:0}}
        this.countTokenTour2 = {0:{local:0,invasif:0},1:{local:0,invasif:0},2:{local:0,invasif:0},3:{local:0,invasif:0},4:{local:0,invasif:0}}
        console.log("Tour 2");
        console.log(this.countTokenTour2);
        for (var i =0;i<randomTokensLocal.length;i++){
            this.regioncorrespondance[i] = randomTokensLocal[i];
        }
        scene.TourCount = 0;
        scene.nbTry = 0;
        scene.isQuizz = false;
        //this.regioncount = [[1,1,1],[1,1,1],[1,1,1]];
        this.regioncount = [[1,1,1,1,1],[1,1,1,1,1],[1,1,1,1,1],[1,1,1,1,1],[1,1,1,1,1]];
        this.regionitem = [false,false,false,false,false];
        let initT = randomTokensLocal;
        let newinitT = [];
        console.log("initT");
        console.log(this.regioncorrespondance);
        console.log(initT);
        this.drawnTokens = []
        this.oldinitTokens = [];
        this.initTokens = [];
        for (var index = 0;index<correspondance.length;index++) {
            let randIndex = Math.floor(Math.random() * initT.length);
            newinitT.push(initT.splice(randIndex, 1)[0]);
        }
        for (var index = 0;index<newinitT.length;index++) {
            this.initTokens.push(this.initTokenLocal(newinitT[index],scene));
        }
        /*for (var index = 0;index<initT.length;index++) {
            let randIndex = Math.floor(Math.random() * this.oldinitTokens.length);
            this.initTokens.push(this.oldinitTokens.splice(randIndex, 1)[0]);
        }*/
        console.log(newinitT);
        console.log(this.initTokens);
        /*this.initTokens = [
            new TokenLocal(scene, TokenLocal.Types.Abeille),
            new TokenLocal(scene, TokenLocal.Types.Ecrevisse),
            new TokenLocal(scene, TokenLocal.Types.Ecureuil),
            new TokenLocal(scene, TokenLocal.Types.Posidonie),
            new TokenLocal(scene, TokenLocal.Types.Statice),
        ]*/
        this.bagTokens = [];
        var typeQuizz = {
            nom: "Quizz"
        }
        var typeKata = {
            nom: "Catastrophe"
        }
        this.bagTokens.push(new TokenQuizz(scene,typeQuizz));
        for (var index = 0;index<correspondance.length;index++) {
            this.bagTokens.push(this.initTour2Invasif(this.regioncorrespondance[index],scene));
            this.bagTokens.push(this.initTour2Invasif(this.regioncorrespondance[index],scene));
            this.bagTokens.push(this.initTour2Action(this.regioncorrespondance[index],scene));
        }
        this.bagTokens.push(new TokenQuizz(scene,typeQuizz));
        this.bagTokens.push(new TokenQuizz(scene,typeQuizz));
        this.bagTokens.push(new TokenQuizz(scene,typeQuizz));
        this.bagTokens.push(new TokenKata(scene,typeKata));
        this.bagTokens.push(new TokenKata(scene,typeKata));
        this.bagTokens.push(new TokenKata(scene,typeKata));
        this.bagTokens.push(new TokenQuizz(scene,typeQuizz));
        this.baglength = this.bagTokens.length;
        /*this.bagTokens = [
            new TokenInvasif(scene, TokenInvasif.Types.Frelon),
            new TokenInvasif(scene, TokenInvasif.Types.Ecrevisse),
            new TokenInvasif(scene, TokenInvasif.Types.Ecureuil),
            new TokenInvasif(scene, TokenInvasif.Types.Caulerpe),
            new TokenInvasif(scene, TokenInvasif.Types.Griffe),

            new TokenAction(scene, TokenAction.Types.Proteger),
            new TokenAction(scene, TokenAction.Types.Capturer),
            new TokenAction(scene, TokenAction.Types.Bongeste),
            new TokenAction(scene, TokenAction.Types.Limiter),
            new TokenAction(scene, TokenAction.Types.Deraciner),

            new TokenQuizz(scene),
            new TokenQuizz(scene),
            new TokenQuizz(scene),

            new TokenKata(scene)
        ]*/
        // this.bagTokens = this.bagTokens.flatMap(i => Array(tokenMultiplier).fill(i))
        /*var topRight = scene.board.getTopRight();
        this.tokenBag =  scene.add.image(topRight.x+50, topRight.y+100, 'bag').setScale(0.7)*/
        //this.testHitAreaZone(scene);
        //this.tokenBag =  scene.add.image(0, 0, 'bag').setScale(0.6)
        /*this.tokenBag.setInteractive();
        this.tokenBag.setAlpha(0.5);*/
        //console.log("TOKEN BAG");
        //console.log(scene.testHitAreas);
        scene.localempty = [];
        for (var i=0;i<5;i++){
            //var x = 300;
            var x = (-screenWidth/scale)/2 + (967) + 190 //position
            var y = -280 + i * 140 - (Math.floor(i/5) * 5 * 140);
            var localempty = scene.add.image(x, y, 'empty');
            localempty.scaleX = scene.jetons.scaleY;
            localempty.scaleY = scene.jetons.scaleY;
            scene.localempty.push(localempty);
        }
        
        let tokenGroup = scene.add.group();
        console.log(this.bagTokens);
        this.initTokenDrag(scene,tokenGroup,correspondance);
        /*axios
      .get(bdd['serveur']+'ajax.php?do=getequipes&id_app=V4a272b306b403327523e2b64542727576b457d4a5c5a4544404b48595b')
      .then(response => (this.info = response.data))
    console.log(this.info)  */    
    }

    initTokenDrag(scene,tokenGroup,correspondance){
        var t = this;
        var childCount = tokenGroup.getChildren().length
        scene.initNoms = [];
        this.initTokens.forEach((item,index)  => {
            //let item = t.bagTokens.splice(randIndex, 1)[0]
            ////this.drawnTokens.push(item)
            this.drawnTokens.push(item)
            tokenGroup.add(item)
            scene.add.existing(item);
            scene.physics.add.existing(item);
            item.setScale(0.7);
            /*item.x = topRight.x+50;
            item.y = topRight.y+50;*/
            //item.x = 300;
            item.x = (-screenWidth/scale)/2 + (967) + 190//position
            item.y = -280 + index * 140 - (Math.floor(index/5) * 5 * 140);
            //scene.add.text(300, -180 + index * 140 - (Math.floor(index/5) * 5 * 140), item.getData("type").nom, {font:'30px "Inter', fill: "#FDE8CF", align:"center",boundsAlignH: "center", boundsAlignV: "middle"}).setOrigin(0.5);;
            const divnom = document.createElement('div');
            var displayw = scene.jetons.displayWidth - 20;
            divnom.style = 'color:#FDE8CF; width: '+displayw+'px; height: auto; font: 15px "Inter";text-align:center;';
            divnom.innerHTML = "<div>"+item.getData("type").nom+"</div>";
            var containernom = scene.add.container(0, 0);
            //var elementnom = scene.add.dom(300, -260 + index * 140 - (Math.floor(index/5) * 5 * 140) + (item.height * item.scaleX)/2, divnom);
            var elementnom = scene.add.dom((-screenWidth/scale)/2 + (967) + 190, -280 + index * 140 - (Math.floor(index/5) * 5 * 140) + (item.height * item.scaleX)/2 +5, divnom);//position
            containernom.add(elementnom);
            scene.initNoms.push(containernom);
            /*scene.tweens.add({
            targets: item,
            // x: 150 + childCount * 80,
            // y: 800,
            //x: 0 + childCount * 80 - (Math.floor(childCount/12) * 12 * 80),
            x: topRight.x + 50,
            y: topRight.y + 100 + index * 80 - (Math.floor(index/5) * 5 * 80),
            duration: 450,
            ease: 'Expo.easeOut',
            onComplete: function(){*/
                item.setData('initialX', item.x)
                item.setData('initialY', item.y)
                item.setData('placed', false)
                item.setData('removing', false)
                item.setData('id',this.idtoken);
                item.setInteractive({
                    useHandCursor: true
                });
                scene.input.setDraggable(item);
                console.log(item);
                this.idtoken += 1;
            /*}
            });*/

            item.on('dragstart', function (pointer, gameObject){ 
            // this.children.bringToTop(item);
                if (!scene.divmanageZonecontainer.visible){
                    this.drag = true;
                }
                console.log("hittestpointer");
                console.log(scene.input.hitTestPointer(pointer));//A VOIR JEUDI TEST DANS ZONE
                //scene.initNoms[index].setVisible(false);
                scene.initNoms[index].destroy();
                scene.boardHitAreas.forEach((area, areaindex) => {
                var p = new Phaser.Geom.Point(pointer.worldX,pointer.worldY);
                console.log('dans drag item');
                console.log(scene.TourCount);
                if (Phaser.Geom.Rectangle.ContainsPoint(area, p)) {
                    if (scene.hitAreasData[areaindex].items.length>0 && scene.TourCount<5 && scene.hitAreasData[areaindex].items[0] == item){
                        item.setData('placed', false);
                        item.setScale(0.7)
                        scene.hitAreasData[areaindex].items=[];
                        scene.TourCount -= 1;
                        this.countTokenTour2[areaindex].local -= 1;
                        console.log('remove item');
                        console.log(scene.hitAreasData[areaindex]);
                    }
                }
                });
            }, this);

            item.on('drag', (pointer, gameObject, dragX, dragY) => {
                if(item.getData('placed')) return 
                if(item.getData('removing')) return
                if (scene.divmanageZonecontainer.visible) return
                item.x = pointer.worldX;
                item.y = pointer.worldY;
                scene.boardHitAreas.forEach((area, areaindex) => {
                    var p = new Phaser.Geom.Point(pointer.worldX,pointer.worldY);

                    if (Phaser.Geom.Rectangle.ContainsPoint(area, p)) {
                        //item.setScale(0.8);
                        console.log("0.8");
                        this.initondrag[areaindex] = true;
                    }
                    else{
                        this.initondrag[areaindex] = false;
                    }
                    /*else{
                        //item.setScale(0.7);
                        console.log("0.7");
                        this.initondrag = false;
                    }*/
                });
                console.log("this.initondrag");
                console.log(this.initondrag);
                if (this.initondrag.includes(true)){
                    item.setScale(0.8);
                }
                else{
                    item.setScale(0.7);
                }
            });

            item.on('dragend', (pointer, gameObject, dragX, dragY) => {
                item.setScale(0.7);
                this.initondrag = [false,false,false,false,false];
                //this.initondrag = false;
            /*scene.testHitAreas.forEach((area, areaindex) => {
                var p = new Phaser.Geom.Point(pointer.worldX,pointer.worldY);
                if (Phaser.Geom.Rectangle.ContainsPoint(area, p) && scene.input.hitTestPointer(pointer).length > 2) {
                    console.log(scene.input.hitTestPointer(pointer));
                    console.log(scene.input);
                }
                else{
                    console.log("TAILLE");
                    console.log(scene.input.hitTestPointer(pointer).length);
                }
            });*/
            scene.boardHitAreas.forEach((area, areaindex) => {
                if(item.getData('placed')) return 
                if(item.getData('removing')) return 
                if (scene.divmanageZonecontainer.visible) return
                this.drag = false;
                var p = new Phaser.Geom.Point(pointer.worldX,pointer.worldY);
                console.log("ITEM");
                console.log(item);
                if (Phaser.Geom.Rectangle.ContainsPoint(area, p)) {
                    //t.putToken(scene, item, index, area)
                    var tokenType = item.getData('token')
                    //t.putToken(scene, item, areaindex, area);
                    t.initPutToken(scene, item, areaindex, area, correspondance,tokenGroup, t);
                    setTimeout(() => {
                        item.once('pointerdown', () => {
                            //item.setData('removing', true)
                            //t.removeToken(scene, item, index)
                        }, this);
                    }, 200)
                    setTimeout(() => {
                        //item.setData('removing', false)
                        //item.setData('placed', false)
                    }, 1000)
                    
                }
                else{
                    item.x = pointer.worldX;
                    item.y = pointer.worldY;
                }
            })
            });
        });
    }

    bagTokenDragandRandom(scene,tokenGroup){
        var t = this;
        this.tokenBag.on('pointerdown', function () {
            if (scene.TourCount >=5 && this.tokenBag.alpha == 1){
                var bagcount = scene.nbTry + 1;
                var nombrepioche = bagcount + '/' +  this.baglength;
                scene.nombrepioche.text = nombrepioche;
                var childCount = tokenGroup.getChildren().length
                // var childCount = t.drawnTokens.length
                if(t.bagTokens.length == 0) return

                let randIndex = Math.floor(Math.random() * t.bagTokens.length);
                let item = t.bagTokens.splice(randIndex, 1)[0]
                //let item = t.bagTokens.splice(0, 1)[0]
                console.log("this.bagTokens");
                console.log(this.bagTokens);
                console.log(scene.nbTry);
                /*let randIndex = scene.nbTry;
                let item = t.bagTokens[randIndex]*/
                this.drawnTokens.push(item)
                tokenGroup.add(item)
                scene.add.existing(item);
                scene.physics.add.existing(item);
                item.setScale(0.7);
                //item.x = 300;
                item.x = (-screenWidth/scale)/2 + (967) + 190//position
                item.y = 310;
                const divnom = document.createElement('div');
                var displayw = scene.jetons.displayWidth - 20;
                divnom.style = 'color:#FDE8CF; width: '+displayw+'px; height: auto; font: 15px "Inter";text-align:center;';
                divnom.innerHTML = "<div>"+item.getData("type").nom+"</div>";
                var containernom = scene.add.container(0, 0);
                //var elementnom = scene.add.dom(300, 310 + (item.height * item.scaleX)/2, divnom);
                var elementnom = scene.add.dom((-screenWidth/scale)/2 + (967) + 190, 310 + (item.height * item.scaleX)/2 +5, divnom);//position
                containernom.add(elementnom);
                scene.tokenNom = containernom;
                scene.tweens.add({
                targets: item,
                // x: 150 + childCount * 80,
                // y: 800,
                //x: 0 + childCount * 80 - (Math.floor(childCount/12) * 12 * 80),
                //y: 200 + Math.floor(childCount/12) * 80,
                /*x: 0 + 1 * 80 - (Math.floor(1/12) * 12 * 80),
                y: 200 + Math.floor(1/12) * 80,*/
                //x: 300,
                x : (-screenWidth/scale)/2 + (967) + 190,//position
                y: 310,
                duration: 450,
                ease: 'Expo.easeOut',
                onComplete: function(){
                    item.setData('initialX', item.x)
                    item.setData('initialY', item.y)
                    item.setData('placed', false)
                    item.setData('removing', false)
                    item.setInteractive({
                        useHandCursor: true
                    });
                    scene.input.setDraggable(item);
                    console.log(item);
                }
                });
                item.on('pointerdown', function (pointer, gameObject){
                    /*console.log("pointerdownquizz");
                    console.log(scene.container); */
                }, this);
                item.on('dragstart', function (pointer, gameObject){ 
                    /*if(item.getData('token')=="quizz"){
                        return
                    }  */
                    if (!scene.isQuizz){
                        this.drag = true;
                    }
                    scene.tokenNom.destroy();
                    
                }, this);

                item.on('drag', (pointer, gameObject, dragX, dragY) => {
                    //if(item.getData('token')=="quizz") return
                    if(item.getData('placed')) return 
                    if(item.getData('removing')) return
                    if(scene.isQuizz) return
                    item.x = pointer.worldX;
                    item.y = pointer.worldY;
                });

                item.on('dragend', (pointer, gameObject, dragX, dragY) => {

                scene.boardHitAreas.forEach((area, index) => {
                    //if(item.getData('token')=="quizz") return
                    if(item.getData('placed')) return 
                    if(item.getData('removing')) return
                    if(scene.isQuizz) return
                    this.drag = false;
                    var p = new Phaser.Geom.Point(pointer.worldX,pointer.worldY);
                    if (Phaser.Geom.Rectangle.ContainsPoint(area, p)) {
                        console.log("dedans");
                        var tokenType = item.getData('token')
                        

                        setTimeout(() => {
                            item.once('pointerdown', () => {
                                /*item.setData('removing', true)
                                t.removeToken(scene, item, index)*/
                            }, this);
                        }, 200)
                        setTimeout(() => {
                            /*item.setData('removing', false)
                            item.setData('placed', false)*/
                        }, 1000)
                        if(item.getData('token')=="quizz"){
                            scene.isQuizz = true;
                            scene.containerinterro.setVisible(false);
                            scene.container.removeAll(true);
                            
                            let randomNumber = Math.floor(Math.random() * (30 - this.nbQ));
                            let randIndex = this.listQ.splice(randomNumber, 1)[0];
                            //randIndex = this.listQ[randomNumber];
                            console.log("TIRAGE QUIZZ")
                            console.log(randomNumber);
                            console.log(randIndex);
                            console.log(this.listQ);
                            console.log(this.baglength);
                            this.nbQ += 1;
                            const div = document.createElement('div');
                            //scene.quizz = new Quizz();
                            /*var qtest = new Quizztest();
                            console.log(qtest.quizz);
                            console.log("Quizz.quizz");*/
                            console.log("scene.quizz");
                            console.log(scene.quizz);
                            var width = scene.quizz.width - 100;
                            div.style = 'color:#2D453D; width: '+width+'px; height: auto; font: 16px "Inter"; font-weight: bold;text-align:center';
                            div.innerHTML = "<div><p style='margin: 20px 20px;margin-bottom: 45px;margin-left:30px;'>"+Quizz[randIndex].question+"</p><p id='Rep1' style='margin-bottom:35px;cursor:pointer;margin-left: 30px;margin-right: 20px;'>"+Quizz[randIndex].reponse1+"</p><p id='Rep2' style='margin-bottom:35px;cursor:pointer;margin-left: 30px;margin-right: 20px;'>"+Quizz[randIndex].reponse2+"</p><p id='Rep3' style='cursor:pointer;margin-left: 30px;margin-right: 20px;'>"+Quizz[randIndex].reponse3+"</p></div>";
                            //var element = scene.add.dom(565, -64, div);
                            var element = scene.add.dom((-screenWidth/scale)/2 + (967) + 455, -64, div);//position
                            scene.container.add(element);
                            scene.container.setVisible(true);
                            var reponse;
                            var bonnereponse = "reponse"+Quizz[randIndex].bonnereponse;
                            var textebonnereponse = Quizz[randIndex][bonnereponse];
                            console.log("textebonnereponse");
                            console.log(textebonnereponse);
                            console.log(Quizz[randIndex].question);
                            document.getElementById('Rep1').onclick = function(){
                                //scene.createScoreAnimation(item.x, item.y, '+' + 3, 3);
                                reponse = 1;
                                if (Quizz[randIndex].bonnereponse == reponse){
                                    scene.createScoreAnimation(item.x, item.y, '+' + 3, 3);
                                    t.showQuizzResult(scene,true,Quizz[randIndex].precision,textebonnereponse);
                                }
                                else{
                                    t.showQuizzResult(scene,false,Quizz[randIndex].precision,textebonnereponse);
                                }
                                t.putQuizzToken(scene, item, index, area, reponse, randIndex)
                                
                            }
                            document.getElementById('Rep2').onclick = function(){
                                reponse = 2;
                                if (Quizz[randIndex].bonnereponse == reponse){
                                    scene.createScoreAnimation(item.x, item.y, '+' + 3, 3);
                                    t.showQuizzResult(scene,true,Quizz[randIndex].precision,textebonnereponse);
                                }
                                else{
                                    t.showQuizzResult(scene,false,Quizz[randIndex].precision,textebonnereponse);
                                }
                                t.putQuizzToken(scene, item, index, area, reponse, randIndex);
                            }
                            document.getElementById('Rep3').onclick = function(){
                                reponse = 3;
                                if (Quizz[randIndex].bonnereponse == reponse){
                                    scene.createScoreAnimation(item.x, item.y, '+' + 3, 3);
                                    t.showQuizzResult(scene,true,Quizz[randIndex].precision,textebonnereponse);
                                }
                                else{
                                    t.showQuizzResult(scene,false,Quizz[randIndex].precision,textebonnereponse);
                                }
                                t.putQuizzToken(scene, item, index, area, reponse, randIndex)
                            }                          
                        }
                        else if(item.getData('token')=="kata"){
                            if (this.countTokenTour2[index].local == 1 && this.countTokenTour2[index].invasif == 1){
                                scene.hitAreasData[index].items[0].setAlpha(0.5);
                                scene.hitAreasData[index].items[0].setData('removing', true)
                                this.countTokenTour2[index].local = 0;
                            }
                            item.destroy(true);
                            this.tokenBag.setAlpha(1);
                            this.messageJouer(scene,"piocher");
                            scene.nbTry += 1;
                            if (scene.nbTry == this.baglength){
                                console.log("FIN");
                                this.checkresult(scene);
                            }
                        }
                        else{
                            t.algoToken(scene, item, index, area)
                            //scene.nbTry += 1;
                            if (scene.nbTry == this.baglength){
                                console.log("FIN");
                                this.checkresult(scene);
                            }
                        }
                        
                    }
                    else{
                        item.x = pointer.worldX;
                        item.y = pointer.worldY;
                    }
                })
                });
            this.tokenBag.setAlpha(0.5);
            this.messageJouer(scene,"jouer");
            }
        }, this);
        
    }

    initPutToken(scene, item, areaIndex, area, correspondance,tokenGroup,t){
        var count = scene.hitAreasData[areaIndex].items.length - scene.hitAreasData[areaIndex].stacked.length;
        let tokens = scene.hitAreasData[areaIndex].items;
        /*console.log(JSON.parse(JSON.stringify(tokens.map( t => {return t.getData('type')}))));
        console.log(tokens[0].getData('type'));*/
        //scene.hitAreasData[areaIndex].items.push(item)
        if(!tokens.length){
            //if (item.getData("type").groupe == this.regioncorrespondance[areaIndex]){
            if (correspondance[areaIndex].includes(item.getData("type").groupe)){
                item.x = area.centerX - 45 + 45 * count;
                item.y = area.centerY;
                item.setScale(0.6)
                item.setData('placed', true)
                scene.hitAreasData[areaIndex].items.push(item)
                console.log("item.getData()");
                console.log(item);
                this.regioncorrespondance[areaIndex] = item.getData("type").groupe;
                console.log("this.regioncorrespondance");
                console.log(this.regioncorrespondance);
                //this.regionitem[areaIndex] = item.getData("type").groupe;
                //var newScore = 5;
                ////var newScore = this.scoreCalculation(this.regioncount[item.getData("id")]);
                scene.TourCount += 1;
                ////scene.createScoreAnimation(item.x, item.y, '+' + newScore, newScore);
                if (scene.TourCount == 5){
                    var newScore = 0;
                    for (var i=0;i<this.regioncount.length;i++){
                        newScore += this.scoreCalculation(this.regioncount[i]);
                    }
                    scene.createScoreAnimation(item.x, item.y, '+' + newScore, newScore);
                    setTimeout(() => {
                        this.showTour2(scene,tokenGroup,t);
                    }, 1000)
                }
                this.countTokenTour2[areaIndex].local += 1;
            }
            /*else if (correspondance[areaIndex].includes(item.getData("type").groupe) && item.getData("type").groupe != this.regioncorrespondance[areaIndex]){
                scene.createScoreAnimation(item.x, item.y, '0', 0);
                scene.divmanageZonecontainer.x = scene.cameras.main.midPoint.x;
                scene.divmanageZonecontainer.y = scene.cameras.main.midPoint.y;
                scene.divmanageZonecontainer.setVisible(true);
            }   */
            else{
                /*console.log(this.regioncount);
                console.log(item.getData("id"));
                console.log(areaIndex);*/
                if (this.regioncount[item.getData("id")][areaIndex]){
                    console.log("scene.cameras.main");
                    console.log(scene.cameras.main.midPoint);
                    scene.container.x = scene.cameras.main.midPoint.x;
                    scene.container.y = scene.cameras.main.midPoint.y;
                    scene.container.setVisible(true);
                    this.regioncount[item.getData("id")][areaIndex] -= 1;
                }
                else {
                    console.log(this.regioncount);
                }
            }
            return
        }
    }

    putToken(scene, item, areaIndex, area){
        //console.log(scene.hitAreasData);
        var count = scene.hitAreasData[areaIndex].items.length - scene.hitAreasData[areaIndex].stacked.length
        //var count = scene.hitAreasData[areaIndex].items.length
        // let tokens = scene.hitAreasData[areaIndex].items.map(i => { return i.getData('type') });
        /*let tokens = scene.hitAreasData[areaIndex].items;
        let tokensData = JSON.parse(JSON.stringify(tokens.map( t => {return t.getData('type')})))
        console.log(tokensData);
        console.log("tokensData");*/
        //console.log(tokens[0].getData('type'));*/
        /*let token = item.getData('token')
        let tokenInfo = JSON.parse(JSON.stringify(item.getData('type')))*/

        //if(!item.getData("placed")){
            //if (item.getData("type").groupe == this.regioncorrespondance[areaIndex]){
                item.x = area.centerX - 45 + 45 * count;
                item.y = area.centerY;
                item.setScale(0.6)
                item.setData('placed', true)
                scene.hitAreasData[areaIndex].items.push(item)
                scene.nbTry += 1;
                this.tokenBag.setAlpha(1);
                this.messageJouer(scene,"piocher");
                /*var newScore = 5;
                scene.createScoreAnimation(item.x, item.y, '+' + newScore, newScore);*/
                return
            //}
        //}

        /*var index = tokensData.findLastIndex(_token => {
            return ( _token.groupe == tokenInfo.groupe  && _token.nom != tokenInfo.nom)
        })
        
        if(index != -1){ // si y'a un token de la "famille" de celui qu'on veut placer
            let tokenPresent = tokens[index]
            switch(token){
                case "invasif":
                    break;
                case "local":
                    break;
                case "action":
                    break;
            }

            item.y = tokenPresent.y + 45;
            item.x = tokenPresent.x;
            scene.hitAreasData[areaIndex].stacked.push(item)
            item.setScale(0.6)
            item.setData('placed', true)
        }
        else{
            item.x = area.centerX - 45 + 45 * count;
            item.y = area.centerY;
            item.setScale(0.6)
            item.setData('placed', true)
        }  */
        

        //scene.hitAreasData[areaIndex].items.push(item)

    }

    putQuizzToken(scene, item, index, area, reponse, randIndex){
        //var count = scene.hitAreasData[areaIndex].items.length
        /*var count = scene.hitAreasData[areaIndex].items.length - scene.hitAreasData[areaIndex].stacked.length;
        console.log("scene.hitAreasData");
        console.log(scene.hitAreasData);
        if (item.getData('token')=="quizz"){
            item.x = area.centerX - 45 + 45 * count;
            item.y = area.centerY;
            item.setScale(0.8)
            item.setData('placed', true)
            //scene.hitAreasData[areaIndex].items.push(item)
            this.tokenBag.setAlpha(1);
            item.destroy(true);
            return
        }*/
        if (Quizz[randIndex].bonnereponse == reponse){
            if (this.countTokenTour2[index].local == 1 && this.countTokenTour2[index].invasif == 1){
                scene.hitAreasData[index].items[1].destroy(true);
                scene.hitAreasData[index].items = [scene.hitAreasData[index].items[0]]
                this.countTokenTour2[index].invasif = 0;
                item.destroy(true);
                //this.tokenBag.setAlpha(1);
                this.messageJouer(scene,"piocher");
            }
            else if (this.countTokenTour2[index].local == 0 && this.countTokenTour2[index].invasif == 1){
                scene.hitAreasData[index].items[1].destroy(true);
                scene.hitAreasData[index].items = [scene.hitAreasData[index].items[0]]
                this.countTokenTour2[index].invasif = 0;
                item.destroy(true);
                //this.tokenBag.setAlpha(1);
                this.messageJouer(scene,"piocher");
            }
            else{
                item.destroy(true);
                //this.tokenBag.setAlpha(1);
                this.messageJouer(scene,"piocher");
            }
        }
        else {
            item.destroy(true);
            //this.tokenBag.setAlpha(1);
            this.messageJouer(scene,"piocher");
        }
        scene.isQuizz = false;
        scene.nbTry += 1;
    }


    randomTokensLocal(correspondance) {
        var randTokens = []
        for (var i = 0;i<correspondance.length; i++){
            let randIndex = Math.floor(Math.random() * correspondance[i].length);
            randTokens.push(correspondance[i][randIndex]);
        }
        return randTokens;
    }

    initTokenLocal(index,scene) {
        switch (index){
            case 0:
                return new TokenLocal(scene, TokenLocal.Types.Abeille)
            case 1:
                return new TokenLocal(scene, TokenLocal.Types.Ecrevisse)
            case 2:
                return new TokenLocal(scene, TokenLocal.Types.Ecureuil)
            case 3:
                return new TokenLocal(scene, TokenLocal.Types.Posidonie)
            case 4:
                return new TokenLocal(scene, TokenLocal.Types.Statice)
            case 5:
                return new TokenLocal(scene, TokenLocal.Types.Palmier)
            case 6:
                return new TokenLocal(scene, TokenLocal.Types.Cistude)
            case 7:
                return new TokenLocal(scene, TokenLocal.Types.Chataignier)
            default:
                console.log("default");
        }
        
    }

    initTour2Invasif(index,scene) {
        switch (index){
            case 0:
                return new TokenInvasif(scene, TokenInvasif.Types.Frelon)
            case 1:
                return new TokenInvasif(scene, TokenInvasif.Types.Ecrevisse)
            case 2:
                return new TokenInvasif(scene, TokenInvasif.Types.Ecureuil)
            case 3:
                return new TokenInvasif(scene, TokenInvasif.Types.Caulerpe)
            case 4:
                return new TokenInvasif(scene, TokenInvasif.Types.Griffe)
            case 5:
                return new TokenInvasif(scene, TokenInvasif.Types.Papillon)
            case 6:
                return new TokenInvasif(scene, TokenInvasif.Types.Tortue)
            case 7:
                return new TokenInvasif(scene, TokenInvasif.Types.Cynips)
            default:
                console.log("default");
        }
        
    }

    initTour2Action(index,scene) {
        switch (index){
            case 0:
                return new TokenAction(scene, TokenAction.Types.Proteger)
            case 1:
                return new TokenAction(scene, TokenAction.Types.Capturer)
            case 2:
                return new TokenAction(scene, TokenAction.Types.Bongeste)
            case 3:
                return new TokenAction(scene, TokenAction.Types.Limiter)
            case 4:
                return new TokenAction(scene, TokenAction.Types.Deraciner)
            case 5:
                return new TokenAction(scene, TokenAction.Types.Utiliser)
            case 6:
                return new TokenAction(scene, TokenAction.Types.Relacher)
            case 7:
                return new TokenAction(scene, TokenAction.Types.Favoriser)
            default:
                console.log("default");
        }
        
    }

    removeToken(scene, item, index){

        //todo pop listes

        scene.hitAreasData[index].items = scene.hitAreasData[index].items.filter(i => {i.nom !== item.nom})
        scene.hitAreasData[index].stacked = scene.hitAreasData[index].stacked.filter(i => {i.nom !== item.nom})


        item.x = item.getData('initialX') + 0;
        item.y = item.getData('initialY') + 0;
        item.setScale(1)
    }

    scoreCalculation(scores){
        var score =  0;
        for(var i =0;i<scores.length;i++){
            score = score + scores[i];
        }
        return score;
    }

    algoToken(scene, item, index, area){
        if (item.getData("token")=="invasif"){
            console.log(scene.hitAreasData[index].items);
            if (item.getData("type").groupe == this.regioncorrespondance[index]){
                if (this.countTokenTour2[index].local == 1 && this.countTokenTour2[index].invasif == 0){
                    console.log("this.countTokenTour2")
                    console.log(this.countTokenTour2)
                    console.log(this.countTokenTour2[index].invasif)
                    this.putToken(scene, item, index, area)
                    this.countTokenTour2[index].invasif = 1;
                }
                else if (this.countTokenTour2[index].local == 1 && this.countTokenTour2[index].invasif == 1){
                    //this.putToken(scene, item, index, area)
                    this.putToken(scene, item, index, area)
                    scene.hitAreasData[index].items[0].setAlpha(0.5);
                    scene.hitAreasData[index].items[0].setData('removing', true)
                    this.countTokenTour2[index].local = 0;
                    this.countTokenTour2[index].invasif = 2;
                }
                else if (this.countTokenTour2[index].local == 0 && this.countTokenTour2[index].invasif == 1){
                    //this.putToken(scene, item, index, area)
                    this.putToken(scene, item, index, area)
                    this.countTokenTour2[index].invasif = 2;
                }
                else{
                    scene.hitAreasData[index].items = [scene.hitAreasData[index].items[0]]
                    scene.hitAreasData[index].items[0].setAlpha(0.5);
                    scene.hitAreasData[index].items[0].setData('removing', true)
                    this.countTokenTour2[index].local = 0;
                    this.putToken(scene, item, index, area)
                    this.countTokenTour2[index].invasif = 1;
                }
            }
        }
        else if (item.getData("token")=="action"){
            if (item.getData("type").groupe == this.regioncorrespondance[index]){
                if (this.countTokenTour2[index].local == 1 && this.countTokenTour2[index].invasif == 1){
                    scene.hitAreasData[index].items[1].destroy(true);
                    scene.hitAreasData[index].items = [scene.hitAreasData[index].items[0]]
                    this.countTokenTour2[index].invasif = 0;
                    item.destroy(true);
                    scene.nbTry += 1;
                    this.tokenBag.setAlpha(1);
                    this.messageJouer(scene,"piocher");
                }
                else if (this.countTokenTour2[index].local == 0 && this.countTokenTour2[index].invasif == 1){
                    scene.hitAreasData[index].items[1].destroy(true);
                    scene.hitAreasData[index].items = [scene.hitAreasData[index].items[0]]
                    this.countTokenTour2[index].invasif = 0;
                    item.destroy(true);
                    scene.nbTry += 1;
                    this.tokenBag.setAlpha(1);
                    this.messageJouer(scene,"piocher");
                }
                else{
                    item.destroy(true);
                    scene.nbTry += 1;
                    this.tokenBag.setAlpha(1);
                    this.messageJouer(scene,"piocher");
                }
            }
        }
    }

    checkresult(scene){
        var local = 0;
        var invasif = 0;
        for(var i=0;i<5;i++){
            local = local + this.countTokenTour2[i].local;
            invasif = invasif + this.countTokenTour2[i].invasif;
        }
        var t = this;
        //local = 1;
        scene.containerinterro.setVisible(false);
        if (local == 5 && invasif == 0){
            scene.createScoreAnimation(0, 0, '+' + 15, 15);
            setTimeout(() => {
                const div = document.createElement('div');
                //div.style = 'background-color: #4488aa;color:white; width: 450px; height: auto; font: 30px Arial; font-weight: bold;text-align:center;border-radius:20px';
                //div.innerHTML = "<div><p>Vous avez gagné !!</p><p><span id='restart'>Rejouer</span></p></div>";
                div.style = 'width:'+screenWidth/scale+'px;height:'+screenHeight/scale+'px;';
                //div.innerHTML = "<div style='background-color: rgba(0, 0, 0, 0.7);width:"+screenWidth/scale+"px;height:"+screenHeight/scale+"px;display:flex;justify-content:center;align-items:center;'><div style='width:1362px;height:1162px;background-repeat:no-repeat;background-position: center;background-size: contain;background-image: url(\""+gagne+"\");color:#2D453D; font: 50px \"Jumbo\";letter-spacing: 10px;font-weight: bold;text-align:center;border-radius:20px'><div style='height: inherit;display: flex;align-items: center;flex-direction: column;justify-content: center;margin: 0 40px;margin-top: 20px;'><p style='margin-bottom:5px;'>GAGNÉ !</p><div id='restart' style='font-size:30px;font-family:Jumbo;background-color:#769D25;color:white;border-radius:50px;margin-top:20px;line-height: 80px;height: 80px;letter-spacing: 10px;cursor:pointer;padding: 0 20px;'>Rejouer</div><div id='classement' style='margin-top: 40px;font-size: 20px;line-height: 20px;font-family: Inter;letter-spacing: 1px;text-decoration: underline;cursor:pointer;'>ENREGISTRE TON SCORE</div><div style='font-family:Grobold;position: absolute;top: 25%;color: #FDE8CF;font-size: 90px;width: 140px;text-align: right;'>"+scene.scoreLabel.text+"</div><div style='font-family: Manga;position: absolute;top: 27%;color: #FDE8CF;font-size: 50px;margin-left: 260px;letter-spacing: 1px;'>PTS</div></div></div></div>";
                //italien
                div.innerHTML = "<div style='background-color: rgba(0, 0, 0, 0.7);width:"+screenWidth/scale+"px;height:"+screenHeight/scale+"px;display:flex;justify-content:center;align-items:center;'><div style='width:1362px;height:1162px;background-repeat:no-repeat;background-position: center;background-size: contain;background-image: url(\""+gagne+"\");color:#2D453D; font: 50px \"Jumbo\";letter-spacing: 10px;font-weight: bold;text-align:center;border-radius:20px'><div style='height: inherit;display: flex;align-items: center;flex-direction: column;justify-content: center;margin: 0 40px;margin-top: 20px;'><p style='margin-bottom:5px;'>VINTO !</p><div id='restart' style='font-size:30px;font-family:Jumbo;background-color:#769D25;color:white;border-radius:50px;margin-top:20px;line-height: 80px;height: 80px;letter-spacing: 10px;cursor:pointer;padding: 0 20px;'>Torna a giocare</div><div id='classement' style='margin-top: 40px;font-size: 20px;line-height: 20px;font-family: Inter;letter-spacing: 1px;text-decoration: underline;cursor:pointer;'>REGISTRA IL TUO PUNTEGGIO</div><div style='font-family:Grobold;position: absolute;top: 25%;color: #FDE8CF;font-size: 90px;width: 140px;text-align: right;'>"+scene.scoreLabel.text+"</div><div style='font-family: Manga;position: absolute;top: 27%;color: #FDE8CF;font-size: 50px;margin-left: 260px;letter-spacing: 1px;'>PTI</div></div></div></div>";
                var element = scene.add.dom(0, 0, div);
                scene.divResultcontainer.add(element);
                scene.divResultcontainer.x = scene.cameras.main.midPoint.x;
                scene.divResultcontainer.y = scene.cameras.main.midPoint.y;
                scene.divResultcontainer.setVisible(true);
                t.restartGame(scene);
                t.table(scene,"1",t);
            }, 1200)
        }
        else if (local == 0){
            setTimeout(() => {
                const div = document.createElement('div');
                /*div.style = 'background-color: #4488aa;color:white; width: 450px; height: auto; font: 30px Arial; font-weight: bold;text-align:center;border-radius:20px';
                div.innerHTML = "<div><p>Vous avez perdu, les espèces locales n'ont pas été préservées !!</p><p><span id='restart'>Rejouer</span></p></div>";*/
                div.style = 'width:'+screenWidth/scale+'px;height:'+screenHeight/scale+'px;';
                //div.innerHTML = "<div style='background-color: rgba(0, 0, 0, 0.7);width:"+screenWidth/scale+"px;height:"+screenHeight/scale+"px;display:flex;justify-content:center;align-items:center;'><div style='width:1362px;height:1162px;background-repeat:no-repeat;background-position: center;background-size: contain;background-image: url(\""+perdu+"\");color:#2D453D; font: 50px \"Jumbo\";letter-spacing: 10px;font-weight: bold;text-align:center;border-radius:20px'><div style='height: inherit;display: flex;align-items: center;flex-direction: column;justify-content: center;margin: 0 40px;margin-top: 20px;'><p style='margin-bottom:5px;'>PERDU...</p><div id='restart' style='font-size:30px;font-family:Jumbo;background-color:#9A2323;color:white;border-radius:50px;margin-top:20px;line-height: 80px;height: 80px;letter-spacing: 10px;cursor:pointer;padding: 0 20px;'>Rejouer</div><div id='classement' style='margin-top: 40px;font-size: 20px;line-height: 20px;font-family: Inter;letter-spacing: 1px;text-decoration: underline;cursor:pointer;'>ENREGISTRE TON SCORE</div><div style='font-family:Grobold;position: absolute;top: 25%;color: #FDE8CF;font-size: 90px;width: 140px;text-align: right;'>"+scene.scoreLabel.text+"</div><div style='font-family: Manga;position: absolute;top: 27%;color: #FDE8CF;font-size: 50px;margin-left: 260px;letter-spacing: 1px;'>PTS</div></div></div></div>";
                //italien
                div.innerHTML = "<div style='background-color: rgba(0, 0, 0, 0.7);width:"+screenWidth/scale+"px;height:"+screenHeight/scale+"px;display:flex;justify-content:center;align-items:center;'><div style='width:1362px;height:1162px;background-repeat:no-repeat;background-position: center;background-size: contain;background-image: url(\""+perdu+"\");color:#2D453D; font: 50px \"Jumbo\";letter-spacing: 10px;font-weight: bold;text-align:center;border-radius:20px'><div style='height: inherit;display: flex;align-items: center;flex-direction: column;justify-content: center;margin: 0 40px;margin-top: 20px;'><p style='margin-bottom:5px;'>PERSO...</p><div id='restart' style='font-size:30px;font-family:Jumbo;background-color:#9A2323;color:white;border-radius:50px;margin-top:20px;line-height: 80px;height: 80px;letter-spacing: 10px;cursor:pointer;padding: 0 20px;'>Torna a giocare</div><div id='classement' style='margin-top: 40px;font-size: 20px;line-height: 20px;font-family: Inter;letter-spacing: 1px;text-decoration: underline;cursor:pointer;'>REGISTRA IL TUO PUNTEGGIO</div><div style='font-family:Grobold;position: absolute;top: 25%;color: #FDE8CF;font-size: 90px;width: 140px;text-align: right;'>"+scene.scoreLabel.text+"</div><div style='font-family: Manga;position: absolute;top: 27%;color: #FDE8CF;font-size: 50px;margin-left: 260px;letter-spacing: 1px;'>PTI</div></div></div></div>";
                var element = scene.add.dom(0, 0, div);
                scene.divResultcontainer.add(element);
                scene.divResultcontainer.x = scene.cameras.main.midPoint.x;
                scene.divResultcontainer.y = scene.cameras.main.midPoint.y;
                scene.divResultcontainer.setVisible(true);
                t.restartGame(scene);
                t.table(scene,"-1",t);
            }, 1200)
            
        }
        else {
            var nbpts = local * 3;
            scene.createScoreAnimation(0, 0, '+' + nbpts, nbpts);
            setTimeout(() => {
                const div = document.createElement('div');
                /*div.style = 'background-color: #4488aa;color:white; width: 450px; height: auto; font: 30px Arial; font-weight: bold;text-align:center;border-radius:20px';
                div.innerHTML = "<div><p>Le jeu est terminé !!</p><p><span id='restart'>Rejouer</span></p></div>";*/
                div.style = 'width:'+screenWidth/scale+'px;height:'+screenHeight/scale+'px;';
                //div.innerHTML = "<div style='background-color: rgba(0, 0, 0, 0.7);width:"+screenWidth/scale+"px;height:"+screenHeight/scale+"px;display:flex;justify-content:center;align-items:center;'><div style='width:1362px;height:1162px;background-repeat:no-repeat;background-position: center;background-size: contain;background-image: url(\""+pasmal+"\");color:#2D453D; font: 50px \"Jumbo\";letter-spacing: 10px;font-weight: bold;text-align:center;border-radius:20px'><div style='height: inherit;display: flex;align-items: center;flex-direction: column;justify-content: center;margin: 0 40px;margin-top: 20px;'><p style='margin-bottom:5px;'>PAS MAL !</p><div id='restart' style='font-size:30px;font-family:Jumbo;background-color:#F28402;color:white;border-radius:50px;margin-top:20px;line-height: 80px;height: 80px;letter-spacing: 10px;cursor:pointer;padding: 0 20px;'>Rejouer</div><div id='classement' style='margin-top: 40px;font-size: 20px;line-height: 20px;font-family: Inter;letter-spacing: 1px;text-decoration: underline;cursor:pointer;'>ENREGISTRE TON SCORE</div><div style='font-family:Grobold;position: absolute;top: 25%;color: #FDE8CF;font-size: 90px;width: 140px;text-align: right;'>"+scene.scoreLabel.text+"</div><div style='font-family: Manga;position: absolute;top: 27%;color: #FDE8CF;font-size: 50px;margin-left: 260px;letter-spacing: 1px;'>PTS</div></div></div></div>";
                //italien
                div.innerHTML = "<div style='background-color: rgba(0, 0, 0, 0.7);width:"+screenWidth/scale+"px;height:"+screenHeight/scale+"px;display:flex;justify-content:center;align-items:center;'><div style='width:1362px;height:1162px;background-repeat:no-repeat;background-position: center;background-size: contain;background-image: url(\""+pasmal+"\");color:#2D453D; font: 50px \"Jumbo\";letter-spacing: 10px;font-weight: bold;text-align:center;border-radius:20px'><div style='height: inherit;display: flex;align-items: center;flex-direction: column;justify-content: center;margin: 0 40px;margin-top: 20px;'><p style='margin-bottom:5px;'>NON MALE !</p><div id='restart' style='font-size:30px;font-family:Jumbo;background-color:#F28402;color:white;border-radius:50px;margin-top:20px;line-height: 80px;height: 80px;letter-spacing: 10px;cursor:pointer;padding: 0 20px;'>Torna a giocare</div><div id='classement' style='margin-top: 40px;font-size: 20px;line-height: 20px;font-family: Inter;letter-spacing: 1px;text-decoration: underline;cursor:pointer;'>REGISTRA IL TUO PUNTEGGIO</div><div style='font-family:Grobold;position: absolute;top: 25%;color: #FDE8CF;font-size: 90px;width: 140px;text-align: right;'>"+scene.scoreLabel.text+"</div><div style='font-family: Manga;position: absolute;top: 27%;color: #FDE8CF;font-size: 50px;margin-left: 260px;letter-spacing: 1px;'>PTI</div></div></div></div>";
                var element = scene.add.dom(0, 0, div);
                scene.divResultcontainer.add(element);
                scene.divResultcontainer.x = scene.cameras.main.midPoint.x;
                scene.divResultcontainer.y = scene.cameras.main.midPoint.y;
                scene.divResultcontainer.setVisible(true);
                t.restartGame(scene);
                t.table(scene,"0",t);
            }, 1200)
            
        }
        
        //if (local == 3 && inva)
        this.tokenBag.setAlpha(0.5);
        this.messageJouer(scene,"jouer");
    }

    /*touchbag(a,b){
        console.log("TOUCHBAG");
        console.log(a);
        console.log(b);
    }*/

    showTour2(scene,tokenGroup,t){
        t.initTokens.forEach((jeton,index)  => {
            jeton.removeInteractive();
            //jeton.setInteractive({cursor: 'unset'});
        });
        console.log(this.initTokens);
        console.log(t.initTokens);
        console.log(scene.initTokens);
        console.log("SHOWTOUR");
        //this.tokenBag.setAlpha(1);
        //console.log(scene.scoreboard)
        //scene.scoreboard.x = 300;
        scene.scoreboard.x = (-screenWidth/scale)/2 + (967) + 190//position
        scene.scoreboard.y = 0
        scene.jetons.destroy();
        //console.log(scene.elementconseil);
        //scene.elementconseil.x = 300;
        scene.elementconseil.x = (-screenWidth/scale)/2 + (967) + 190//position
        scene.elementconseil.y = -300;
        //scene.scoreLabel.x = 300;
        scene.scoreLabel.x = (-screenWidth/scale)/2 + (967) + 190//position
        scene.scoreLabel.y = 20;
        //scene.scorePosition.x = 360;
        scene.scorePosition.x = (-screenWidth/scale)/2 + (967) + 250//position
        scene.scorePosition.y = 20;
        for (var i=0;i<5;i++){
            scene.localempty[i].destroy();
        }
        //scene.jetonsac= scene.add.image(450, 300, 'jetonsac');
        scene.jetonsac= scene.add.image((-screenWidth/scale)/2 + (967) + 340, 300, 'jetonsac');//position
        scene.jetonsac.scaleX = scene.jetons.scaleY;
        scene.jetonsac.scaleY = scene.jetons.scaleY;
        //this.tokenBag =  scene.add.image(565, 330, 'bag').setScale(scene.jetons.scaleY);
        this.tokenBag =  scene.add.image((-screenWidth/scale)/2 + (967) + 445, 330, 'bag').setScale(scene.jetons.scaleY);//position
        this.tokenBag.setInteractive({
            useHandCursor: true
        });
        //scene.quizz =  scene.add.image(565, -64, 'quizzimg').setScale(scene.jetons.scaleY);
        scene.quizz =  scene.add.image((-screenWidth/scale)/2 + (967) + 455, -64, 'quizzimg').setScale(scene.jetons.scaleY);//position
        const divinterro = document.createElement('div');
        divinterro.style = 'font:110px "Grobold";color:#2D453D;';
        divinterro.innerHTML = "<div>?</div>";
        scene.containerinterro = scene.add.container(0, 0);
        //scene.elementinterro = scene.add.dom(565, -44, divinterro);
        scene.elementinterro = scene.add.dom((-screenWidth/scale)/2 + (967) + 455, -44, divinterro);//position
        scene.containerinterro.add(scene.elementinterro);
        //let tokenGroup = scene.add.group();
        this.bagTokenDragandRandom(scene,tokenGroup);
        //var x = 300;
        var x = (-screenWidth/scale)/2 + (967) + 190;//position
        var y = 310;
        scene.localempty = scene.add.image(x, y, 'empty');
        scene.localempty.scaleX = scene.jetons.scaleY;
        scene.localempty.scaleY = scene.jetons.scaleY;
        var nombrepioche = scene.nbTry + '/' +  this.baglength;
        scene.nombrepioche = scene.add.text((-screenWidth/scale)/2 + (967) + 500, 230, nombrepioche, {font:'30px "Grobold"', fill: "#32443d", align:"center",boundsAlignH: "center", boundsAlignV: "middle"});//position
        console.log("scene.containerconseil");
        console.log(scene.containerconseil);
        this.messageJouer(scene,"piocher");
    }

    testHitAreaZone(scene){
        scene.testBag =  scene.add.image(-700, 320, 'bag').setScale(0.7);
        scene.testBag.name = "bag";
        scene.physics.add.existing(scene.testBag);
        scene.testBag.setInteractive((scene.input.makePixelPerfect()));
        scene.testHitAreas = [scene.testBag.getBounds()]
    }

    showQuizzResult(scene,result,texte,reponse){
        const divQuizz = document.createElement('div');
        divQuizz.style = 'width:'+screenWidth/scale+'px;height:'+screenHeight/scale+'px;';
        if (result){
            divQuizz.innerHTML = "<div style='background-color: rgba(0, 0, 0, 0.2);width:"+screenWidth/scale+"px;height:"+screenHeight/scale+"px;display:flex;align-items:end;'><div style='width:577px;height:404px;background-repeat:no-repeat;background-position: center;background-size: contain;background-image: url(\""+message+"\");color:#2D453D; font: 18px \"Inter\"; font-weight: bold;text-align:center;border-radius:20px'><div style='height: inherit;display: flex;align-items: center;flex-direction: column;justify-content: center;margin: 0 40px;'><p style='margin-bottom:5px;'>Bonne réponse !</p><p style='margin-bottom:5px;'>"+reponse+"</p><p style='margin-bottom:5px;'>"+texte+"</p><div id='messageQuizzOk' style='font-size:40px;font-family:Jumbo;background-color:#32443d;color:white;width:200px;border-radius:50px;margin-top:20px;line-height: 80px;height: 80px;letter-spacing: 10px;cursor:pointer;'>Ok</div></div></div></div>";
        }
        else{
            divQuizz.innerHTML = "<div style='background-color: rgba(0, 0, 0, 0.2);width:"+screenWidth/scale+"px;height:"+screenHeight/scale+"px;display:flex;align-items:end;'><div style='width:577px;height:404px;background-repeat:no-repeat;background-position: center;background-size: contain;background-image: url(\""+message+"\");color:#2D453D; font: 18px \"Inter\"; font-weight: bold;text-align:center;border-radius:20px'><div style='height: inherit;display: flex;align-items: center;flex-direction: column;justify-content: center;margin: 0 40px;'><p style='margin-bottom:5px;'>Mauvaise réponse !</p><p style='margin-bottom:5px;'>"+reponse+"</p><p style='margin-bottom:5px;'>"+texte+"</p><div id='messageQuizzOk' style='font-size:40px;font-family:Jumbo;background-color:#32443d;color:white;width:200px;border-radius:50px;margin-top:20px;line-height: 80px;height: 80px;letter-spacing: 10px;cursor:pointer;'>Ok</div></div></div></div>";
        }
        scene.divQuizzelement = scene.add.dom(0, 0, divQuizz);
        scene.divQuizzcontainer.add(scene.divQuizzelement);
        scene.divQuizzcontainer.x = scene.cameras.main.midPoint.x;
        scene.divQuizzcontainer.y = scene.cameras.main.midPoint.y;
        scene.divQuizzcontainer.setVisible(true);
        var t=this;
        document.getElementById('messageQuizzOk').onclick = function(){
            console.log("DANSGETELEMENTBYID");
            scene.divQuizzcontainer.setVisible(false);
            scene.divQuizzcontainer.removeAll(true);
            scene.container.setVisible(false);
            scene.containerinterro.setVisible(true);
            if (scene.nbTry == t.baglength){
                console.log("FIN");
                t.checkresult(scene);
            }
            else {
                t.tokenBag.setAlpha(1);
            }
            
        }
        console.log("DANSSHOWQUIZZ");
        
        
    }

    restartGame(scene){
        document.getElementById('restart').onclick = function(){
            scene.registry.destroy();
            scene.events.off();
            scene.scene.restart();
        }  
    }

    table(scene,result,t){
        document.getElementById('classement').onclick = function(){
            scene.divTablecontainer.x = scene.cameras.main.midPoint.x;
            scene.divTablecontainer.y = scene.cameras.main.midPoint.y;
            scene.divTablecontainer.setVisible(true);
            scene.divResultcontainer.setVisible(false);
            document.getElementById('croix').onclick = function(){
                scene.divTablecontainer.setVisible(false);
                scene.divResultcontainer.setVisible(true);
            }
            document.getElementById('okname').onclick = function(){
                //var classement = [{"nom":"vincent ruiz","score":"30","result":"1"},{"nom":"vincent ruiz","score":"20","result":"1"},{"nom":"vincent ruiz","score":"10","result":"1"},{"nom":"test4","score":"0","result":"1"}];
                if (document.getElementById('nomequipe').value != ""){
                    var nom = document.getElementById('nomequipe').value;
                    //var reponse;
                    this.reponse = {};
                    //scene.scoreLabel.text = 43;
                    var url = "https://aliem-network.eu/mobiles.php?name=SimpleDataExt&op=save_game_score&score={%22score%22:"+scene.scoreLabel.text+",%22nom%22:%22"+nom+"%22,%22result%22:1}";
                    console.log(url);
                    axios.get(url).then(response => (t.showTable(response.data)));
                    console.log(this.reponse);
                    /*var div = "<div style='400px;overflow-y:scroll;'>";
                    for (var i=0;i<reponse.classement;i++){
                        var place = i+1;
                        div += "<div style='display:flex;'>"
                        div += "<div>"+place+"</div>"
                        div += "<div>"+reponse.classement[i].nom+"</div>"
                        div += "<div>"+reponse.classement[i].score+"</div>"
                        div += "</div>";
                    }
                    div += "</div>"*/
                    document.getElementById('showTable').innerHTML = nom;
                    document.getElementById('okname').style.display = 'none';
                    document.getElementById('nomequipe').style.display = 'none';
                    document.getElementById('textenom').style.display = 'none';
                }
                
            }
        }  
    }

    showTable(response){
        console.log(response);
        var div = "<div style='height:480px;overflow-y:scroll;color:white;font-family:Inter';align-items: center;>";
        var place = 1;
        var score;
        for (var i=0;i<response.classement.length;i++){
            //var place = i+1;
            if (score){
                if (score !=response.classement[i].score){
                    place = i+1;
                }
            }
            console.log("testtable");
            console.log(document.getElementById('nomequipe').value==response.classement[i].nom);
            console.log(document.getElementById('nomequipe').value);
            console.log(response.classement[i].nom);
            console.log(place  == response.position);
            console.log(place);
            console.log(response.position);
            if (place == response.position && document.getElementById('nomequipe').value==response.classement[i].nom){
                div += "<div style='display:flex;background-color:#59786E;align-items: center;border-radius: 20px;border: solid 3px #DAB71C;padding: 20px 40px;margin-bottom: 20px;'>"
                div += "<div style='margin-right:20px;font-family:Grobold;text-align: center;color: #2D453D;font-size: 45px;padding-top: 10px;'>"+place+"</div>"
                div += "<div style='font-family:Inter;width:100%;text-align:left;font-size: 45px;display: flex;text-transform: uppercase;letter-spacing: 1px;width: 100%;-webkit-line-clamp: 1;-webkit-box-orient: vertical;display: -webkit-box;'>"+response.classement[i].nom+"</div>"
                div += "<div style='font-family:Grobold;padding-top: 10px;color: #DAB71C;font-size: 45px;'>"+response.classement[i].score+"</div>"
                div += "</div>";
            }
            else {
                div += "<div style='display:flex;background-color:#59786E;align-items: center;border-radius: 20px;padding: 15px 30px;margin-bottom: 20px;'>"
                div += "<div style='margin-right:20px;font-family:Grobold;text-align: center;color: #2D453D;font-size: 40px;padding-top: 10px;'>"+place+"</div>"
                div += "<div style='font-family:Inter;width:100%;text-align:left;font-size: 40px;display: flex;text-transform: uppercase;letter-spacing: 1px;width: 100%;-webkit-line-clamp: 1;-webkit-box-orient: vertical;display: -webkit-box;'>"+response.classement[i].nom+"</div>"
                div += "<div style='font-family:Grobold;padding-top: 10px;color: #DAB71C;font-size: 40px;'>"+response.classement[i].score+"</div>"
                div += "</div>";
            }
            score = response.classement[i].score;
        }
        div += "</div>"
        document.getElementById('showTable').innerHTML = div;
    }

    messageJouer(scene,message){
        /*const divconseil = document.createElement('div');
        divconseil.style = 'color:#DAB71C; width: '+this.scoreboard.displayWidth+'px; height: auto; font: 50px "Manga";text-align:center;';
        divconseil.innerHTML = "<div>A toi de jouer&nbsp!</div>";
        //italien
        //divconseil.innerHTML = "<div>È il tuo turno di giocare&nbsp!</div>";
        this.containerconseil = this.add.container(0, 0);
        this.elementconseil = this.add.dom((-screenWidth/scale)/2 + (967) + 440, -250, divconseil);//position
        this.elementconseil.scaleX = this.jetons.scaleY;
        this.elementconseil.scaleY = this.jetons.scaleY;
        this.containerconseil.add(this.elementconseil);*/
        console.log(scene.elementconseil)
        //scene.containerconseil.remove(scene.elementconseil)
        
        if (message =="jouer"){
            scene.elementconseil.node.innerHTML = "<div>Sta a te di giocare&nbsp!</div>";
        }
        if (message =="piocher"){
            scene.elementconseil.node.innerHTML = "<div>Sta a te di disegnare&nbsp!</div>";
        }
    }
}

